import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { a as pesRouterNavigationType, s as store } from './pes-router-store-0c1092be.js';
import './currency-7be6806c.js';
import './index-54dd34b7.js';

const map = ['country', 'language', 'page', 'pageId', 'businessId', 'userType'];
function parseUrl(navigation, base_dir) {
  const segments = (navigation === pesRouterNavigationType.HASH
    ? window.location.hash.replace('#', '')
    : window.location.pathname)
    .replace(new RegExp('^/'), '');
  const baseDirNoSlash = base_dir.replace(/^\//, '').replace(/\/$/, '');
  if (segments === '' || new RegExp(`^${base_dir}/?$`).test(segments)) {
    return {
      base_dir: baseDirNoSlash,
    };
  }
  const paramMap = segments
    .replace(new RegExp(`^${baseDirNoSlash || ''}/?`), '')
    .replace(/\/$/, '')
    .split('/');
  const routeObj = {
    base_dir: baseDirNoSlash,
    searchParams: {},
  };
  paramMap.forEach((item, index) => {
    if (item && map[index]) {
      routeObj[map[index]] = item;
    }
  });
  new URLSearchParams(window.location.search).forEach((value, key) => {
    routeObj.searchParams[key] = value;
  });
  return routeObj;
}

const PesRouter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.navigation = 'path';
    this.base_dir = '';
    this.store = store;
  }
  setNavigation() {
    this.setupRouterState();
  }
  setBaseDir() {
    this.setupRouterState();
  }
  setupRouterState() {
    const route = parseUrl(this.navigation, this.base_dir);
    this.store.set('usePesRouter', true);
    this.store.set('navigation', this.navigation);
    for (const [key, value] of Object.entries(route)) {
      this.store.set(key, value);
    }
  }
  componentWillLoad() {
    this.setupRouterState();
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  static get watchers() { return {
    "navigation": ["setNavigation"],
    "base_dir": ["setBaseDir"]
  }; }
};

export { PesRouter as pes_router };
